module.exports = __webpack_public_path__ + "static/media/client21.98115cf5.webp";